export default "__VITE_ASSET__Fg0dV$o9__"